import * as React from 'react';
import config from '../../../server/config';
import request from '../../../server/request';

export default class AuthPersonal extends React.Component <any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      data: {}, // 数据
      industry: '', // 行业
    };
  }

  public componentDidMount() {
    this.getData();
  }

  render() {
    const state = this.state;
    return (
      <div>
        {
          this.renderStateAction()
        }
        <ul className="personal">
          <li>
            <div className="personal-tit">
              <b>*</b>
              <p>账号/移动电话</p>
            </div>
            <span className="textmarket">{state.data.mobile || ''}</span>
          </li>
          <li>
            <div className="personal-tit">
              <b>*</b>
              <p>姓&emsp;&emsp;名</p>
            </div>
            <span className="textmarket">{state.data.trueName || ''}</span>
          </li>
          <li>
            <div className="personal-tit">
              <b>&nbsp;</b>
              <p>固定电话</p>
            </div>
            <span className="textmarket">{state.data.phone || ''}</span>
          </li>
          <li>
            <div className="personal-tit">
              <b>*</b>
              <p>电子邮箱</p>
            </div>
            <span className="textmarket">{state.data.email || ''}</span>
          </li>
          <li>
            <div className="personal-tit">
              <b>&nbsp;</b>
              <p>QQ账号</p>
            </div>
            <span className="textmarket">{state.data.qq || ''}</span>
          </li>
          <li>
            <div className="personal-tit">
              <b>&nbsp;</b>
              <p>微&emsp;&emsp;信</p>
            </div>
            <span className="textmarket">{state.data.weChat || ''}</span>
          </li>
          <li>
            <div className="personal-tit">
              <b>*</b>
              <p>职&emsp;&emsp;务</p>
            </div>
            <span className="textmarket">{state.data.duty || ''}</span>
          </li>
          <li>
            <div className="personal-tit">
              <b>*</b>
              <p>部&emsp;&emsp;门</p>
            </div>
            <div className="Location">
              <div>{state.data.deptName || ''}</div>
            </div>
          </li>
          <li>
            <div className="personal-tit">
              <b>*</b>
              <p>公司名称</p>
            </div>
            <span className="textmarket">{state.data.company || ''}</span>
          </li>
          <li>
            <div className="personal-tit">
              <b>*</b>
              <p>公司地区</p>
            </div>
            <div className="Location">
              <div>{state.data.companyArea || ''}</div>
            </div>
          </li>
          <li>
            <div className="personal-tit">
              <b>*</b>
              <p>详细地址</p>
            </div>
            <span className="textmarket">{state.data.companyAddress || ''}</span>
          </li>
          <li>
            <div className="personal-tit">
              <b>*</b>
              <p>主营产品</p>
            </div>
            <span className="textmarket">{state.data.mainBusiness || ''}</span>
          </li>
          <li>
            <div className="personal-tit"><b>*</b><p>所在行业</p></div>
            <div className="Location industry-content-views"><div>{state.industry || ''}</div></div>
          </li>
        </ul>
      </div> 
    );
  }
  // 获取数据
  private async getData() {
    const r = await request({
        url: `${config.API}member/info`
    });
    if(r.code === 1) {
        this.setState({
            data: r.obj
        });
        this.getIndustry();
    } 
  }
  // 根据不同状态渲染不同头部
  private renderStateAction() {
    if(this.state.data.personalAuthenticationStatus > 0) {
      return (
        <div className="state">
          <div className="stateing"><img src={require('@/assets/images/state1.png')} /><em>
            {
              this.state.data.personalAuthenticationStatus == 1 ? '已认证' : '待重新认证'
            }
            </em>
          </div>
          <button onClick={() => this.navigateToApply()}>认证变更</button>
        </div>
      )
    } else if(this.state.data.authenticationStatus == 20) {
      return (
      <div className="state">
          <div className="stateing">
            <img src={require('@/assets/images/state1.png')} />
            <em>审核中</em>
          </div>
          <button disabled>认证变更</button>
        </div>
      )
    } else {
      return (
        <div className="state">
          <div className="stateing">
            <img src={require('@/assets/images/state1.png')} />
            <em>未认证</em>
          </div>
          <button onClick={() => this.navigateToApply()}>立即认证</button>
        </div>
      );
    }
  }
  // 获取个人认证所在行业
  private async getIndustry() {
    const r = await request({
      url: `${config.API}member/info/industry`
    });
    if(r.code === 1) {
      const industry = this.state.data.industry ? this.state.data.industry.split(',') : [];
      let industryStr = '';
      for(let i=0,l=r.obj.length; i<l; i++) {
        for(let j=0,k=industry.length; j<k; j++) {
          if(r.obj[i].id == industry[j]) {
            industryStr += (' ' + r.obj[i].name);
            break;
          }
        }
      }
      this.setState({industry: industryStr});
    }
  }
  // 认证变更
  private navigateToApply() {
    this.props.history.push('/authentication/papply');
  }
}
